<div ngbAccordion>
  @for (item of faqItems; track item.question) {
  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton>{{ item.question }}</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template> {{ item.answer }} </ng-template>
      </div>
    </div>
  </div>
  }
</div>
